import { create, v, w } from '@dojo/framework/core/vdom';
import { Icon } from '@holmescorp/base-widgets';
import { userstate, createNlsMiddleware } from '@holmescorp/lcc-state';
import { isEmpty } from 'lodash-es';
const factory = create({
    userstate,
    nls: createNlsMiddleware('ditabook')
});
export const status = factory(({ middleware: { userstate, nls } }) => {
    const { format } = nls();
    const pass_threshold = 80;
    let quizScore = '...';
    let reading = '...';
    let contentPlus = { quizScore, reading };
    const api = {
        data(key) {
            const { get, path } = userstate;
            const state = get(path('status'));
            let content = {};
            if (!isEmpty(state)) {
                const status = state[key];
                content = status.data;
                const { complete, total } = content;
                const readingComplete = complete === total;
                const percent = () => {
                    const { percent } = content;
                    const pct = Math.round(percent * 100);
                    const pctStr = `${pct}%`;
                    return { pct, pctStr };
                };
                const passed = () => {
                    const { pct } = percent();
                    return pct > pass_threshold;
                };
                const { pct, pctStr: percentStr } = percent();
                const quizPassed = passed();
                const quizFail = !quizPassed;
                const quizStarted = (quizPassed || quizFail) && pct > 0;
                const failIcon = v('span', { style: 'color: red' }, [w(Icon, { faname: 'exclamation-circle' })]);
                quizScore =
                    quizStarted && quizFail
                        ? v('span', {}, [v('span', {}, [percentStr]), failIcon])
                        : quizStarted && quizPassed
                            ? percentStr
                            : '...';
                reading = complete > 0 ? format('complete_of_total', { complete, total }) : '...';
                contentPlus = Object.assign({
                    percentStr,
                    reading,
                    quizScore,
                    quizPassed,
                    quizFail,
                    quizStarted,
                    readingComplete,
                    failIcon
                }, content);
            }
            return contentPlus;
        }
    };
    return api;
});
